import { VectorLayerState } from '../../../../core/outputs/annotation/annotation-shared/state/layers/vector-layer-state';
import { AnnotationState2D } from '../../annotation-shared/state/root/annotation-state-2d';

export class VideoState extends AnnotationState2D {
  override layers!: VectorLayerState[];
  mlAssistRange = 0;
  redirectShortcutsToPointCloud = false;
}
